import React, { FC } from "react";
import { ServiceInfoDc, TableInfoDc, WorkspaceLimitsDc } from "@evergis/api";

import { isReadable } from "../../../../../evergis/core/permissions";
import { RestrictedWidthContainer } from "../../../DialogComponents/styled";
import { TableStructureInfo } from "./hooks/useGetTableStructure";
import { TableStructureControls } from "./hooks/useTableStructureControls";
import { ProjectCopyOptionsContainer } from "./styled";
import { ProjectCopyTableStructure } from "./TableStructure";

export interface ProjectCopyOptionsProps {
  deps: {
    layers: ServiceInfoDc[];
    tables: TableInfoDc[];
  };
  tableStructure: TableStructureInfo[];
  tableStructureControls: TableStructureControls;
  limits: WorkspaceLimitsDc | undefined;
}

export const CopyProjectOptions: FC<ProjectCopyOptionsProps> = props => {
  const { deps } = props;

  const tablesReadableCount: number =
    deps && deps.tables
      ? deps.tables.filter(table => {
          return isReadable(table.permissions);
        }).length
      : 0;

  const layersReadableCount: number =
    deps && deps.layers
      ? deps.layers.filter(layer => {
          return isReadable(layer.permissions);
        }).length
      : 0;

  if (tablesReadableCount + layersReadableCount === 0) {
    return null;
  }

  return (
    <RestrictedWidthContainer>
      <ProjectCopyOptionsContainer>
        <ProjectCopyTableStructure {...props} />
      </ProjectCopyOptionsContainer>
    </RestrictedWidthContainer>
  );
};
